export const STEP = 24
export const DEFAULT_VALUE_STEP = 240
export const DISPLAY_MESSAGE = 'MTR_STEPPER_MESSAGE'
export const SECONDS_IN_1HR = 3600
